import React from "react"
import { RichTextElement } from "@kentico/gatsby-kontent-components"
import { Link } from "gatsby"
import ImageCollection from "./imagecollection"

const KontentRichText = (data) => {
  const item = data.item

  return ( 
    <RichTextElement 
    value={item.value}
    images={item.images}
    links={item.links}
    linkedItems={item.modular_content}
    resolveImage={image => {
      return (
{/*        <img
          src={image.url}
          alt={image.description ? image.description : image.name}
          width="200"
        />
*/}
      )
    }}
    resolveLink={(link, domNode) => {
      return (
        <Link to={`/${link.type}/${link.url_slug}`}>
          {domNode.children[0].data}
        </Link>
      )
    }}
    resolveLinkedItem={linkedItem => {
      switch (linkedItem.system.type) {
        case "image_collection":
          return <ImageCollection linkedItem={linkedItem} />
        default: {
          return <pre>{JSON.stringify(linkedItem, undefined, 2)}</pre>
        }
      }
    }}
    />
  )
}

export default KontentRichText

